import React from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const About = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });
  const cards = useInView({ threshold: 0.3 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={inView && { opacity: 1 }}
      transition={{
        type: "keyframes",
        duration: window.matchMedia("(max-width: 850px)").matches ? 0.5 : 1.5,
        bounce: 1,
        delay: window.matchMedia("(max-width: 850px)").matches ? 0 : 0.5,
      }}
      className="About mt-3"
      id="#aboutSection"
    >
      <div className="h-relative mx-auto">
        <h1 className="fw-bold Section-heading">ABOUT ME</h1>
      </div>
      <p className="text-center mt-3 about-text">
        Here you will find more information about me, what I do, and my current
        skills which are primarily in programming and technology.
      </p>
      <div className="d-flex justify-content-between About-content mt-5">
        <div className="w-50">
          <h2 className="fw-bold">Get to know me!</h2>
          <p className="mt-4 about-text">
            As a MERN stack developer with over{" "}
            <span className="highlight">2 years </span> of professional
            experience, I've had the opportunity to build{" "}
            <span className="highlight"> diverse range of projects</span>,
            solving complex problems and delivering efficient solutions.
            Alongside my professional journey, I've also been working as a{" "}
            <span className="highlight">dedicated freelancer</span>,
            collaborating with clients worldwide to bring their visions to life.
            <br />
            <br />
            My coding journey began during the challenging times of the COVID-19
            pandemic, and I took the initiative to learn programming from
            various online resources, including YouTube. Being a{" "}
            <span className="highlight">self-taught programmer </span> has
            instilled in me a deep appreciation for continuous learning and the
            perseverance needed to stay ahead in the ever-evolving tech
            industry.
            <br />
            <br />I aim to contribute my skills and creativity to meaningful
            projects that make a difference.{" "}
            <span className="highlight"> Let's connect </span> and explore how
            we can work together to achieve your digital aspirations.
          </p>
        </div>
        <motion.div
          ref={cards.ref}
          className="Skills w-50 ms-4"
          initial={{
            opacity: 0,
            scale: window.matchMedia("(max-width: 550px)").matches ? 0.8 : 0,
          }}
          animate={
            inView && {
              opacity: 1,
              scale: 1,
              transition: {
                type: "keyframes",
                duration: 1,
                bounce: 1,
                delay: 0.3,
              },
            }
          }
        >
          <h2 className="fw-bold">My Skills</h2>
          <div className="d-flex flex-wrap mt-3">
            <div className="skill-box">HTML</div>
            <div className="skill-box">CSS</div>
            <div className="skill-box">JAVASCRIPT</div>
            <div className="skill-box">BOOTSTRAP</div>
            <div className="skill-box">Tailwind CSS</div>
            <div className="skill-box">REACT</div>
            <div className="skill-box">NEXT JS</div>
            <div className="skill-box">Node JS</div>
            <div className="skill-box">Express JS</div>
            <div className="skill-box">MongoDB</div>
            <div className="skill-box">Firebase</div>
            <div className="skill-box">GIT & GITHUB</div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default About;
